/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { ContactDashboardPage } from './pages/ContactDashboardPage'

export const ContactLayout: FC = () => <ContactDashboardPage />
